module.exports = __webpack_public_path__ + "img/back-white.ee5cdaa6.svg";